import { render, staticRenderFns } from "./modalConfirmarLevantamento.vue?vue&type=template&id=4fdd7f73&scoped=true"
import script from "./modalConfirmarLevantamento.vue?vue&type=script&lang=js"
export * from "./modalConfirmarLevantamento.vue?vue&type=script&lang=js"
import style0 from "./modalConfirmarLevantamento.vue?vue&type=style&index=0&id=4fdd7f73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdd7f73",
  null
  
)

export default component.exports